<style>
    #card-element {
        height: 40px;
        padding: 10px 12px;
        width: 100%;
        color: #32325d;
        background-color: white;
        border: 1px solid #ccc;
        border-radius: 4px;
        box-shadow: 0 1px 3px 0 #e6ebf1;
        -webkit-transition: box-shadow 150ms ease;
        transition: box-shadow 150ms ease;
    }

    #card-element:focus {
        box-shadow: 0 1px 3px 0 #cfd7df;
    }

    #card-element.invalid {
        border-color: #fa755a;
    }

    #card-element .StripeElement--invalid {
        border-color: #fa755a;
    }

    #card-element .StripeElement--webkit-autofill {
        background-color: #fefde5 !important;
    }

</style>

<template>
    <div>
        <div class="t_center">
            <h4 class="t_center m-t-30"><b>{{ $t('subscribe_to_pump_my_lead') }}</b></h4>
        </div>
        <div class="row">
            <div class="col-sm-6 col-md-4 t_right t_sm_center">
                <h3 class="m-t-0 m-b-5">R$ 39,90</h3>
                <p>{{ $t('per_user_month') }}</p>
            </div>
            <div class="col-sm-6 col-md-8">
                <ul>
                    <li>{{ $t('_subscription.line_01') }}</li>
                    <li>{{ $t('_subscription.line_02') }}</li>
                    <li>{{ $t('_subscription.line_03') }}</li>
                    <!-- <li>{{ $t('_subscription.line_04') }}</li> -->
                </ul>
            </div>
        </div>
        <hr>

        <!-- Proccess signature -->
        <div class="fade_payment" v-if="isLoading">
            <div class="w_full t_center">
                <h3 class="m-b-50"><i class="ti-lock m-r-10"></i> {{ $t('safe_environment') }}</h3>
                <i class="fa fa-credit-card-alt text-muted fa-4x"></i>
                <p class="text-muted m-t-10 m-b-30 t_uppercase">{{ $t('card_validating_sign_up_subscription') }}</p>

                <!-- Balls Animated -->
                <div class="ball_payment space--huge">
                    <div class="preloader preloader__track preloader--bounce space--normal">
                        <div class="preloader__ball">
                            <div class="ball"></div>
                        </div>
                        <div class="preloader__ball">
                            <div class="ball"></div>
                        </div>
                        <div class="preloader__ball">
                            <div class="ball"></div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <form @submit.prevent="subscribe">
            <div class="t_center" id="card-element"></div>
            <div class="m-t-20">
                <iframe src="https://www.pumpmylead.com/termos-de-uso" class="terms" frameborder="0"></iframe>
            </div>
            <div class="t_center">
                <div class="clearfix m-b-20">
                    <pml-checkbox v-model="acceptTerms" :label="$t('_subscription.line_06')"></pml-checkbox>
                </div>
                <button class="btn btn-rounded over_hide" :class="{ 'btn-default': canSubmit }" :disabled="!canSubmit">
                    <span class="btn-label btn-label-left"><i class="fa fa-star"></i></span>{{ $t('subscribe_now') }}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
    import {create} from '@/services/subscriptions'
    import {subscriptionCompleted} from '@/utils/helpers/sweet-alert'
    import {mapGetters, mapActions} from 'vuex'
    import {loadStripe} from '@stripe/stripe-js'

    export default {
        name: 'Subscription',
        data () {
            return {
                acceptTerms: false,
                isLoading: false,
                record: {
                    token: ''
                },
                token: '',
                cardElement: null,
                stripe: null,
                errors: []
            }
        },
        computed: {
            ...mapGetters({
                'tenant': 'getTenant'
            }),
            canSubmit () {
                if (this.acceptTerms === true)
                    return true

                return false
            }
        },
        async mounted () {
            this.stripe = await loadStripe(process.env.STRIPE_API_KEY)
            const elements = this.stripe.elements()
            const style = {
                base: {
                    iconColor: '#c4f0ff',
                    color: '#000',
                    fontWeight: 500,
                    fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
                    fontSize: '16px',
                    fontSmoothing: 'antialiased',
                    '::placeholder': {
                        color: '#87BBFD'
                    },
                    ':-webkit-autofill': {
                        color: '#fce883'
                    }
                },
                invalid: {
                    iconColor: '#FFC7EE',
                    color: '#FFC7EE'
                }
            }
            this.cardElement = elements.create('card', {style, hidePostalCode: true})
            this.cardElement.mount('#card-element')
        },
        methods: {
            ...mapActions([ 'setTenant' ]),
            async getToken () {
                const { token, error } = await this.stripe.createToken(this.cardElement)

                if (error)
                    console.error('Erro ao criar token:', error)

                return token
            },
            async subscribe () {
                if (!this.canSubmit) return

                this.isLoading = true
                try {
                    const token = await this.getToken()
                    if (!token)
                        throw new Error('Token não obtido')

                    this.record.token = token
                    await create(this.record)
                        .then(response => {
                            this.setTenant(response.data)
                            subscriptionCompleted()
                            this.$emit('cardRefresh')
                        })
                        .catch(error => {
                            if (error.response && error.response.data) {
                                this.errors = error.response.data.errors || []
                            } else {
                                console.error('Erro na resposta:', error)
                                this.errors = ['Ocorreu um erro inesperado.']
                            }
                        })
                } catch (error) {
                    console.error('Erro durante o processo de subscrição:', error.message)
                } finally {
                    this.isLoading = false
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/company/components/billing/subscriptions/New.vue